import { render, staticRenderFns } from "./editVehicleType.vue?vue&type=template&id=5ce83a5d&scoped=true&"
import script from "./editVehicleType.vue?vue&type=script&lang=js&"
export * from "./editVehicleType.vue?vue&type=script&lang=js&"
import style0 from "./editVehicleType.vue?vue&type=style&index=0&id=5ce83a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce83a5d",
  null
  
)

export default component.exports